import React, { useEffect, useMemo, useRef, useState } from "react";
import "./NewPrices.css";
import MultiSelectInput from "./MultiSelectInput.jsx";
import moment from "moment";
import CategoryContainer from "./CategoryContainer.jsx";
import Draggable from "react-draggable";
import ModalChangePricesAndQuotas from "./ModalChangePricesAndQuotas.jsx";
import axios from "axios";

const VectorPrices = (props) => {
    const [startDate, setStartDate] = useState(moment().toDate());
    const [endDate, setEndDate] = useState(moment().add(1, "d").toDate());
    const [months, setMonths] = useState([]);
    const [selectedDates, setSelectedDates] = useState([]);
    const [selectedRate, setSelectedRate] = useState([props.rates[0]]);
    const [selectedFields, setSelectedFields] = useState([props.fields[0]]);
    const [selectedRoomTypes, setSelectedRoomTypes] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [isOpenPriceModal, setIsOpenPriceModal] = useState(false);
    const [isOpenPriceQuota, setIsOpenPriceQuota] = useState(false);
    const [lastOpen, setLastOpen] = useState("");
    // const [roomTypes, setRoomTypes] = useState(props.roomTypes);
    // const [rates, setRates] = useState(props.rates);
    const [update, setUpdate] = useState(false);

    useEffect(() => {
        if (endDate) {
            const params = {
                rate_id: selectedRate[0]?.id,
                startDate: moment(startDate).format("YYYY-MM-DD"),
                endDate: moment(endDate).format("YYYY-MM-DD"),
            };

            props.initAction(params, "vector_prices");
        }
    }, [selectedRate, endDate, update]);

    useEffect(() => {
        if (selectedDates.length < 1) {
            setModalIsOpen(false);
        }
    }, [selectedDates]);

    // Получение тарифа и дат из юрл
    useEffect(() => {
        const currentUrl = window.location.href;
        const url = new URL(currentUrl);
        const params = new URLSearchParams(url.search);

        let startDate = params.get("startDate");
        let endDate = params.get("endDate");
        const rateId = params.get("rate_id");

        const today = moment();
        const tomorrow = moment(today).add(1, "day");

        if (startDate && moment(startDate).isBefore(today)) {
            startDate = today.format("YYYY-MM-DD");
            params.set("startDate", startDate);
        }

        if (endDate && moment(endDate).isBefore(today)) {
            endDate = tomorrow.format("YYYY-MM-DD");
            params.set("endDate", endDate);
        }

        if (startDate || endDate) {
            const newUrl = `${window.location.pathname}?${params.toString()}`;
            window.history.replaceState(null, "", newUrl);
        }

        if (rateId && props.rates) {
            setSelectedRate(props.rates.filter((r) => r.id === +rateId));
        }

        if (startDate) {
            setStartDate(moment(startDate).toDate());
        }

        if (endDate) {
            setEndDate(moment(endDate).toDate());
        }
    }, []);

    const [state, setState] = useState({
        isSelecting: false,
        startX: 0,
        startY: 0,
        deleted: false,
    });

    const dateString = `${moment(startDate).format("DD.MM.YY")} — ${
        moment(endDate).format("DD.MM.YY") !== "Invalid date"
            ? moment(endDate).format("DD.MM.YY")
            : ""
    }`;

    //создает промежутки дат в модалке редактирования
    const datesStingsMemo = useMemo(() => {
        const momentDates = sortedDates(selectedDates).map((date) =>
            moment(date, "DD.MM.YY"),
        );
        if (momentDates.length === 0) {
            return [];
        }
        const result = [];

        let start = momentDates[0];
        let end = momentDates[0];
        for (let i = 1; i < momentDates.length; i++) {
            const currentDate = momentDates[i];
            const diff = currentDate.diff(end, "days");
            if (diff === 1) {
                end = currentDate;
            } else {
                if (start.isSame(end, "day")) {
                    result.push(start.format("DD.MM.YY"));
                } else {
                    result.push(
                        `${start.format("DD.MM.YY")} — ${end.format(
                            "DD.MM.YY",
                        )}`,
                    );
                }
                start = end = currentDate;
            }
        }

        if (start.isSame(end, "day")) {
            result.push(start.format("DD.MM.YY"));
        } else {
            result.push(
                `${start.format("DD.MM.YY")} — ${end.format("DD.MM.YY")}`,
            );
        }

        return result;
    }, [selectedDates]);

    //установки при смене дат
    useEffect(() => {
        if (endDate) {
            const newMonths = [];
            let currentDate = moment(startDate);
            while (currentDate.isSameOrBefore(endDate)) {
                const monthYear = currentDate.format("MMM'YY");
                if (!newMonths.includes(monthYear)) {
                    newMonths.push(monthYear);
                }
                currentDate.add(1, "day");
            }
            setMonths(newMonths);
            setSelectedDates([]);
        }
    }, [endDate]);

    const daysWeek = ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"];

    //метод создающий саму таблицу
    const generateMonthDates = (
        startDate,
        endDate,
        month,
        monthNumber,
        thisCategory = false,
        prices = [],
        roomTypeId = null,
    ) => {
        let currentDate = moment(startDate);

        const dayNumber =
            monthNumber === 0
                ? currentDate.day()
                : moment(month, "MMM'YY").startOf("month").day();

        const dates = new Array((dayNumber === 0 ? 7 : dayNumber) - 1).fill(
            "empty",
        );

        while (currentDate.isSameOrBefore(moment(endDate, "day"))) {
            const currentMonth = currentDate.format("MMM'YY");

            if (currentMonth === month) {
                const data = {
                    price: prices?.[currentDate.format("YYYY-MM-DD")]?.[
                        roomTypeId
                    ]?.[1],
                    date: currentDate.format("DD.MM.YY"),
                    quotaStatus:
                        prices?.[currentDate.format("YYYY-MM-DD")]?.[
                            roomTypeId
                        ]?.[0]?.[0],
                    priceStatus:
                        prices?.[currentDate.format("YYYY-MM-DD")]?.[
                            roomTypeId
                        ]?.[0]?.[1],
                };
                dates.push(data);
            }
            currentDate.add(1, "day");
        }

        if (thisCategory) {
            let insertCount = 0;
            dates.unshift("title_row");

            for (let i = 8; i <= dates.length + 3; i += 9) {
                if (dates[i - insertCount - 1] && dates[i - insertCount]) {
                    dates.splice(i - insertCount, 0, "title_row");
                }
                insertCount++;
            }

            const lastDate = dates[dates.length - 1].date;
            const lastDayOfWeek =
                moment(lastDate, "DD.MM.YY").day() === 0
                    ? 7
                    : moment(lastDate, "DD.MM.YY").day();

            for (let i = 0; i < 7 - lastDayOfWeek; i++) {
                dates.push("empty");
            }
        }

        return dates;
    };

    //событие клика мыши в календаре
    const handleMouseDown = (event, date, isDel) => {
        event.preventDefault();
        handleCloseAllMultiSelects();
        setState((prevState) => ({
            ...prevState,
            isSelecting: true,
            startX: event.clientX,
            startY: event.clientY,
            deleted: isDel,
        }));
        if (!state.isSelecting) {
            setSelectedDates((prevSelectedDates) => {
                if (!prevSelectedDates.includes(date)) {
                    return [...prevSelectedDates, date];
                } else {
                    return prevSelectedDates.filter(
                        (selectedDate) => selectedDate !== date,
                    );
                }
            });
        }
    };

    //мультивыбор дат в календаре, при зажатой кнопке мыши
    const handleMouseMove = (event) => {
        if (!state.isSelecting) return;

        document.querySelectorAll(".day").forEach((item) => {
            const rect = item.getBoundingClientRect();
            if (
                Math.min(state.startX, event.clientX) !== 0 &&
                Math.min(state.startY, event.clientY) !== 0 &&
                rect.left <= Math.max(state.startX, event.clientX) &&
                rect.top <= Math.max(state.startY, event.clientY) &&
                rect.right >= Math.min(state.startX, event.clientX) &&
                rect.bottom >= Math.min(state.startY, event.clientY)
            ) {
                const itemDate = item.getAttribute("data-id");

                if (state.deleted) {
                    setSelectedDates((pr) =>
                        pr.filter((selectedDate) => selectedDate !== itemDate),
                    );
                } else {
                    if (!selectedDates.includes(itemDate)) {
                        setSelectedDates((pr) => [...pr, itemDate]);
                    }
                }
            }
        });
    };

    //отпустили кнопку мыши остановили мультивыбор
    const handleMouseUp = () => {
        setState((prevState) => ({
            ...prevState,
            isSelecting: false,
        }));

        if (state.isSelecting && selectedDates.length > 0) {
            setModalIsOpen(true);
        }
    };

    //ушли за границу календаря - имитируем отпускание кнопки мыши
    const handleMouseLeave = () => {
        setState((prevState) => ({
            ...prevState,
            isSelecting: false,
        }));

        if (state.isSelecting) {
            setModalIsOpen(true);
        }
    };

    //модалка где стоимость, квота, закрыть, и т.д.
    const handleOpenModalPanel = () => {
        if (selectedDates.length == 0) {
            alert("Выберите даты");
        } else {
            setModalIsOpen((pr) => !pr);
            handleCloseAllMultiSelects();
        }
    };

    const draggableRef = useRef(null);

    //закрытие мультиселектов
    const handleCloseAllMultiSelects = () => {
        setLastOpen("");
    };

    //выбрать все даты\снять выбор со всех
    const selectedAllDates = (all = false) => {
        handleCloseAllMultiSelects();
        if (all) {
            const allDatesInRange = [];

            let currentDate = moment(startDate, "DD.MM.YY").clone();
            while (currentDate.isSameOrBefore(endDate)) {
                allDatesInRange.push(currentDate.format("DD.MM.YY"));
                currentDate.add(1, "day");
            }
            setSelectedDates(allDatesInRange);
            setModalIsOpen(true);
        } else {
            setSelectedDates([]);
            setModalIsOpen(false);
        }
    };

    const miniPricePanelIcon = (
        <svg
            onClick={handleOpenModalPanel}
            className="mini-price_panel_icon"
            width="44px"
            height="44px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.2929 2.29289C11.6834 1.90237 12.3166 1.90237 12.7071 2.29289L16.7071 6.29289C17.0976 6.68342 17.0976 7.31658 16.7071 7.70711C16.3166 8.09763 15.6834 8.09763 15.2929 7.70711L13 5.41421V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V5.41421L8.70711 7.70711C8.31658 8.09763 7.68342 8.09763 7.29289 7.70711C6.90237 7.31658 6.90237 6.68342 7.29289 6.29289L11.2929 2.29289ZM5 13C5 11.3431 6.34315 10 8 10H9C9.55228 10 10 10.4477 10 11C10 11.5523 9.55228 12 9 12H8C7.44772 12 7 12.4477 7 13V19C7 19.5523 7.44772 20 8 20H16C16.5523 20 17 19.5523 17 19V13C17 12.4477 16.5523 12 16 12H15C14.4477 12 14 11.5523 14 11C14 10.4477 14.4477 10 15 10H16C17.6569 10 19 11.3431 19 13V19C19 20.6569 17.6569 22 16 22H8C6.34315 22 5 20.6569 5 19V13Z"
                    fill="#000000"
                ></path>
            </g>
        </svg>
    );

    //формирование таблицы
    const monthsMemo = useMemo(() => {
        return months.map((month, idx) => (
            <div key={month + "_month"} className="month-container">
                <div
                    className={
                        "month-name_container" +
                        (idx === 0 ? " month-first" : "")
                    }
                >
                    <div className="month">{month.split("'")[0]}'</div>
                    <div className="year">{month.split("'")[1]}</div>
                </div>
                <div className="calendar">
                    {idx === 0 &&
                        daysWeek.map((d) => (
                            <div
                                key={`day-is-${d}`}
                                className={
                                    "day-week" +
                                    (d === "СБ" || d === "ВС"
                                        ? " day-weekend"
                                        : "")
                                }
                            >
                                {d}
                            </div>
                        ))}
                    {generateMonthDates(startDate, endDate, month, idx).map(
                        (date, index) => {
                            const includesDates = selectedDates.includes(
                                date.date,
                            );
                            return date === "empty" ? (
                                <div
                                    key={`days_calendar_${index}_${date}`}
                                ></div>
                            ) : (
                                <div
                                    key={`days_calendar_${index}_${date}`}
                                    className={includesDates ? "striped" : ""}
                                >
                                    <div
                                        data-id={date.date}
                                        key={`days_calendar_${index}_${date.date}`}
                                        className={
                                            "day mouse-select__selectable" +
                                            ([0, 6].includes(
                                                moment(
                                                    date.date,
                                                    "DD.MM.YY",
                                                ).day(),
                                            )
                                                ? " week-end"
                                                : "") +
                                            (includesDates
                                                ? " selected-dates"
                                                : "")
                                        }
                                        onMouseDown={(e) =>
                                            handleMouseDown(
                                                e,
                                                date.date,
                                                includesDates,
                                            )
                                        }
                                    >
                                        {date.date}
                                    </div>
                                </div>
                            );
                        },
                    )}
                </div>
            </div>
        ));
    }, [months, props.prices, selectedDates, state.isSelecting]);

    //открыти модалки изменения стоимости
    const handleOpenModalPrice = () => {
        handleCloseAllMultiSelects();
        if (cleanFields(selectedFields, "Квота", true)?.length > 0) {
            setIsOpenPriceModal((pr) => !pr);
        } else {
            alert("Добавьте поля");
        }
    };

    //открыти модалки изменения квот
    const handleOpenModalQuota = () => {
        handleCloseAllMultiSelects();
        if (
            selectedFields?.length > 0 &&
            selectedFields?.some((f) => f.name === "Квота")
        ) {
            setIsOpenPriceQuota((pr) => !pr);
        } else {
            alert("Добавьте поле Квота");
        }
    };

    //сохранение цен\квот на бек
    const handleSubmit = (e, data, thisQuotas = false) => {
        e.preventDefault();

        const roomTypesIds = selectedRoomTypes.map((roomType) => roomType.id);

        if (thisQuotas) {
            axios
                .post(`/manager/data/hotels/${props?.hotelId}/vector_prices`, {
                    fieldId: 0,
                    data,
                    roomTypesIds,
                    selectedDates,
                    rateId: selectedRate[0].id,
                    variant: "multiple",
                })
                .then((res) => setUpdate((pr) => !pr));
        } else {
            axios
                .post(`/manager/data/hotels/${props?.hotelId}/vector_prices`, {
                    data,
                    roomTypesIds,
                    selectedDates,
                    rateId: selectedRate[0].id,
                    variant: "multiple",
                })
                .then((res) => setUpdate((pr) => !pr));
        }
    };

    const savePrice = (newPrice) => {
        axios
            .post(`/manager/data/hotels/${props?.hotelId}/vector_prices`, {
                ...newPrice,
                rateId: selectedRate[0].id,
                variant: "single",
            })
            .then((res) => setUpdate((pr) => !pr));

        const formattedDate = moment(newPrice.date, "DD.MM.YY").format(
            "YYYY-MM-DD",
        );

        updatePrice(props.prices, newPrice, formattedDate);
    };

    const handleSales = (variant) => {
        const roomTypesIds = selectedRoomTypes.map((roomType) => roomType.id);

        axios
            .post(`/manager/data/hotels/${props?.hotelId}/vector_prices`, {
                roomTypesIds,
                selectedDates,
                rateId: selectedRate[0].id,
                variant,
            })
            .then((res) => setUpdate((pr) => !pr));
    };

    return (
        <>
            <h1 className={"title_prices"}>Цены и квоты</h1>
            <div className={"main_prices"}>
                <div className={"panel"}>
                    <MultiSelectInput
                        options={props.rates}
                        place={"Тарифы"}
                        downLabel={`Доступно ${props.rates.length} тарифов`}
                        selectedOptions={selectedRate}
                        setSelectedOptions={setSelectedRate}
                        lastOpen={lastOpen}
                        setLastOpen={setLastOpen}
                        thisRates={1}
                    />
                    <MultiSelectInput
                        place={"Даты"}
                        downLabel={"Максимально 180 дней"}
                        thisDates={1}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        dateString={dateString}
                        lastOpen={lastOpen}
                        setLastOpen={setLastOpen}
                    />
                    <MultiSelectInput
                        options={props.fields}
                        place={"Поля"}
                        downLabel={`Доступно ${props.fields.length} квот`}
                        selectedOptions={selectedFields}
                        setSelectedOptions={setSelectedFields}
                        lastOpen={lastOpen}
                        setLastOpen={setLastOpen}
                    />
                    <MultiSelectInput
                        options={props.roomTypes}
                        place={"Категории"}
                        downLabel={`Доступно ${props.roomTypes.length} категорий`}
                        selectedOptions={selectedRoomTypes}
                        setSelectedOptions={setSelectedRoomTypes}
                        lastOpen={lastOpen}
                        setLastOpen={setLastOpen}
                    />
                </div>
                <div
                    className="main-calendar"
                    onClick={() => handleCloseAllMultiSelects()}
                >
                    <div
                        className="calendar-container"
                        onMouseUp={handleMouseUp}
                        onMouseLeave={handleMouseLeave}
                        onMouseMove={handleMouseMove}
                    >
                        <div className="folding-container">
                            <span
                                onClick={() => selectedAllDates(true)}
                                className="checkmark"
                            >
                                &#10004;
                            </span>
                            <span
                                onClick={() => selectedAllDates(false)}
                                className="cross"
                            >
                                &#10008;
                            </span>
                        </div>
                        {monthsMemo}
                    </div>
                </div>
                <div>
                    {selectedRoomTypes.map((roomType) => (
                        <CategoryContainer
                            key={roomType.id + "_" + roomType.name}
                            roomType={roomType}
                            dates={sortedDates(selectedDates)}
                            selectedFields={selectedFields.sort(
                                (a, b) => a.id - b.id,
                            )}
                            generateMonthDates={generateMonthDates}
                            startDate={startDate}
                            endDate={endDate}
                            months={months}
                            selectedDates={selectedDates}
                            prices={props.prices}
                            handleCloseAllMultiSelects={
                                handleCloseAllMultiSelects
                            }
                            savePrice={savePrice}
                        />
                    ))}
                </div>
                {modalIsOpen ? (
                    <Draggable nodeRef={draggableRef}>
                        <div
                            ref={draggableRef}
                            key={"modal-custom"}
                            className="modal-custom"
                        >
                            <div className="modal-first__row">
                                <div className="dates-container">
                                    {datesStingsMemo?.map((d) => (
                                        <div
                                            key={"modal_day_" + d}
                                            className="modal-first__row__child dates-child"
                                        >
                                            {d}
                                        </div>
                                    ))}
                                </div>
                                <div className="modal-first__row__child">
                                    {selectedRoomTypes.length > 0
                                        ? selectedRoomTypes.map(
                                              (rT, rTx) =>
                                                  rT.name +
                                                  (rTx ===
                                                  selectedRoomTypes.length - 1
                                                      ? ""
                                                      : ", "),
                                          )
                                        : "Выберите категории"}
                                </div>
                            </div>
                            <div className="modal-buttons">
                                <button
                                    onClick={handleOpenModalPrice}
                                    className="modal-button black-button"
                                >
                                    Стоимость
                                </button>
                                <button
                                    onClick={handleOpenModalQuota}
                                    className="modal-button black-button"
                                >
                                    Квота
                                </button>
                                <button
                                    onClick={() => handleSales("openSales")}
                                    className="modal-button green-button"
                                >
                                    Открыть продажи
                                </button>
                                <button
                                    onClick={() => handleSales("closeSales")}
                                    className="modal-button red-button"
                                >
                                    Закрыть продажи
                                </button>
                                <button className="modal-button green-button">
                                    Забронировать
                                </button>
                                <button
                                    onClick={handleOpenModalPanel}
                                    className="modal-button red-button"
                                >
                                    Свернуть
                                </button>
                            </div>
                        </div>
                    </Draggable>
                ) : (
                    <div className="mini-price_panel">{miniPricePanelIcon}</div>
                )}
            </div>

            {isOpenPriceModal && selectedFields.length > 0 && (
                <ModalChangePricesAndQuotas
                    handleSubmit={handleSubmit}
                    isOpenModal={isOpenPriceModal}
                    setClose={setIsOpenPriceModal}
                    handleOpenModal={handleOpenModalPrice}
                    thisPrices={true}
                    selectedFields={selectedFields}
                    title={"Массовое редактирование стоимости"}
                />
            )}

            {isOpenPriceQuota && selectedFields.length > 0 && (
                <ModalChangePricesAndQuotas
                    handleSubmit={handleSubmit}
                    isOpenModal={isOpenPriceQuota}
                    handleOpenModal={handleOpenModalQuota}
                    selectedFields={selectedFields}
                    setClose={setIsOpenPriceQuota}
                    thisQuotas={true}
                    title={"Массовое редактирование квоты"}
                />
            )}
        </>
    );
};

export default VectorPrices;

const sortedDates = (dates) => {
    return dates.sort((a, b) =>
        moment(a, "DD.MM.YY").diff(moment(b, "DD.MM.YY")),
    );
};

const updatePrice = (prices, newPrice, formattedDate) => {
    if (!prices[formattedDate]) {
        prices[formattedDate] = {};
    }

    if (!prices[formattedDate][newPrice.roomTypeId]) {
        prices[formattedDate][newPrice.roomTypeId] = [];
    }

    if (!prices[formattedDate][newPrice.roomTypeId][1]) {
        prices[formattedDate][newPrice.roomTypeId][1] = {};
    }

    if (newPrice.fieldId === 0) {
        prices[formattedDate][newPrice.roomTypeId][1][newPrice.fieldId][0] =
            newPrice.price;
    } else {
        prices[formattedDate][newPrice.roomTypeId][1][newPrice.fieldId] =
            newPrice.price;
    }
};

export const cleanFields = (fields, name, thisPrice = false) =>
    fields?.filter((f) => (thisPrice ? f.name !== name : f.name === name));
